<template>
    <FullFillBox
        :pageID="1013"
        @permissionData="(data) => {
                this.permissionDetails = data
            }"
    >
        <h3>{{ $t('product_multi_upload_img') }}</h3>
        <hr>
        <div class="product-multi-image">
            <p class="error-text">{{ $t('product_multi_format1') }}</p>
            <p class="error-text">{{ $t('product_multi_format2') }}</p>
            <p>{{ $t('product_multi_format3') }}</p>
            <p>
                {{ $t('product_upload_select_file') }}
                <span>
                    <input type="file" @change="selectMultiImages($event)" multiple accept=".png, .jpg, .jpeg, .gif" id="imageInput">
                </span>
                <button class="btn btn-primary" @click="uploadMultiImage" v-if="nowTableLength > 0">
                    {{ $t('common_upload') }}
                </button>
            </p>

            <div id="imageTableErrorDetail">
                <hr>
                <p class="error-text">{{ imageErrorText }}</p>
                <p>
                    <button class="btn btn-warning" type="button"
                            data-bs-toggle="collapse" data-bs-target="#collapseExample"
                            aria-expanded="false" aria-controls="collapseExample">
                        {{ $t('error_expand_error_details') }}
                    </button>
                </p>
                <div class="collapse" id="collapseExample">
                    <div id="errorDetailList"></div>
                </div>
            </div>

            <hr>
            <p>
                <span>{{ $t('common_row_selected') }} {{ selectedRowsNum }}</span>
                <button class="btn btn-primary"
                        style="margin-left: 100px" @click="delSelectedImage"
                        v-if="selectedRowsNum > 0"
                >
                    {{ $t('product_multi_del_selected') }}
                </button>
            </p>

            <hr>
            <div ref="tabulatorTableUse"></div>
        </div>
    </FullFillBox>

    <vue-easy-lightbox
        :visible="lightboxShow"
        :imgs="imagesSrc"
        :index=0
        :zoomScale=1
        @hide="lightboxShow = false">
    </vue-easy-lightbox>
</template>

<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import VueEasyLightbox from "vue-easy-lightbox/external-css";
import {TabulatorFull as Tabulator} from "tabulator-tables";

export default {
    name: "ProductImageUploadView",
    data(){
        return {
            permissionDetails: {},
            imageID: 1,
            nowTableLength: 0,
            selectedRowsNum: 0,
            imagesSrc: '',
            imageErrorList: [],
            imageErrorText: '',

            lightboxShow: false,
            lightboxIndex: 0,
        }
    },
    components: {
        FullFillBox,
        VueEasyLightbox,
    },
    methods: {
        getImgUrl(file){
            return URL.createObjectURL(file)
        },
        selectMultiImages(e){
            let imagesList = this.tabulator.getData()
            for(let i=0;i<e.target.files.length;i++){
                let thisImage = e.target.files.item(i)
                let thisImageName = e.target.files.item(i).name
                let thisImageOutCode = ""
                if(thisImageName.includes("__")){
                    thisImageOutCode = thisImageName.split('__')[0]
                }else{
                    thisImageOutCode = thisImageName.split('.')[0]
                }
                let newImageData = {
                    "id": this.imageID,
                    "outCode": thisImageOutCode,
                    "fileName": thisImageName,
                    "image_url": this.getImgUrl(thisImage),
                    "image": thisImage
                }

                imagesList.push(newImageData)

                this.imageID += 1
            }
            this.tabulator.setData(imagesList)
            this.tabulator.redraw()
            this.nowTableLength = this.tabulator.getData().length

            document.getElementById("imageInput").value = "";
        },
        delSelectedImage(e, cell){
            this.$swal.fire({
                title: this.$t('common_confirm_action_delete'),
                confirmButtonText: this.$t('common_delete'),
            }).then((result) => {
                if (result.isConfirmed) {
                    let deleteNow = this.tabulator.getSelectedData().map(a => a.id);
                    this.tabulator.setData(this.tabulator.getData().filter(a => !deleteNow.includes(a.id)))
                    this.nowTableLength = this.tabulator.getData().length
                }
            })
        },
        async uploadMultiImage() {
            this.$store.commit('setIsTopLoading', true)

            // Reset Error and data
            document.getElementById('imageTableErrorDetail').style.display = 'none'
            this.imageErrorList = []
            this.imageErrorText = ''

            let nowImageList = this.tabulator.getData()
            let isError = false

            for (let i = 0; i < nowImageList.length; i++) {
               await this.uploadImageToServer(nowImageList.at(i))
            }

            if (this.imageErrorList.length > 0) {
                document.getElementById('imageTableErrorDetail').style.display = 'block'

                let errorsRowList = this.imageErrorList
                this.imageErrorText = this.$t('error_error_list')
                for(let e=0;e<errorsRowList.length;e++){
                    if(e === errorsRowList.length-1){
                        this.imageErrorText += errorsRowList[e]['id']
                    }else{
                        this.imageErrorText += errorsRowList[e]['id'] + ", "
                    }
                }

                let parent = document.getElementById('errorDetailList')
                let getErrorList = this.imageErrorList
                for (let i = 0; i < getErrorList.length; i++) {
                    let htmlContent = await this.$serverErrorReturn(getErrorList[i]['details'])
                    let subParent =
                        "<div class='row' style='background-color: #d4d5e5;border: solid grey 1px;border-radius: 15px'>" +
                        "<div class='col-3 my-auto'>" +
                        "<h4><strong>" + this.$t('common_row') + " " + getErrorList[i]['id'] + "</strong></h4>" +
                        "</div>" +
                        "<div class='col-9'>" + htmlContent + "</div>" +
                        "</div><br>"
                    parent.innerHTML += subParent
                }
                this.$store.commit('setIsTopLoading', false)
            }else{
                this.$toast.success(this.$t('common_success'))
                this.$store.commit('setIsTopLoading', false)
                this.$router.push('/product')
            }
        },
        async uploadImageToServer(getData){
            let formData = new FormData()
            formData.append('id', getData.id)
            formData.append('outCode', getData.outCode)
            formData.append('fileName', getData.fileName)
            formData.append('image_url', getData.image_url)
            formData.append('image', getData.image)

            await this.$mainApi.post(`/api/product/upload-images/`, formData, {
                headers: {
                    "content-type": "multipart/form-data"
                }
            })
                .then(response => {
                    if(response.data.status === 80){
                        // Success, pass
                        // Don't redirect, cuz this is inside a loop
                        return true
                    }else if(response.data.status === 0){
                        // Error
                        let thisImageError = {
                            "id": response.data.details.id,
                            "details": response.data.details.error
                        }
                        this.imageErrorList.push(thisImageError)
                        return false
                    }else{
                        return false
                    }
                })
        }
    },
    mounted(){
        document.title = this.$t('title') + ' | ' + this.$t('product_multi_upload_img')

        this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
            data: [],
            columns: [
                {field: 'id', resizable: false, sorter: 'number', minWidth: 10,  responsive: 0,},
                {formatter:"image", headerHozAlign:"center", hozAlign:"left", resizable:false, field: 'image_url',
                    minWidth: 100, responsive: 0, headerSort:false, headerMenu: this.getHeaderMenu,
                    formatterParams:{
                        height:"130px",
                        width:"100px",
                        urlPrefix: '',
                        urlSuffix: '',
                    },
                    cellClick: (e, cell) => {
                        this.lightboxShow = true
                        this.imagesSrc = cell.getRow().getData().image_url
                    }
                },
                {
                    title: 'File Name', field: 'fileName', sorter: 'string', resizable: false,
                    responsive: 5, minWidth: 300,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_outCode'), field: 'outCode', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 200,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                    editor:"input",
                },
                {
                    formatter: () => {
                        return "<i class='bi bi-trash-fill'></i>"
                    },
                    headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", resizable: false,
                    headerMenu: this.getHeaderMenu,
                    headerSort: false, width: 10, responsive: 0,
                    cellClick: (e, row, formatterParams) => {
                        this.delSelectedImage()
                    }
                },
            ],
            reactiveData: true, //enable data reactivity
            maxHeight: '90vh',
            responsiveLayout: 'collapse',
            layout: "fitColumns",
            movableColumns: true,
            movableRows: false,
            selectable:true,
            selectableRangeMode:"click",
            initialSort: [
                {column: "outCode", dir: "asc"},
            ]
        })
        this.tabulator.on('rowSelectionChanged', (data, rows) => {
            this.selectedRowsNum = rows.length
        })
        document.getElementById('imageTableErrorDetail').style.display = 'none'
    }
}
</script>

<style scoped>

</style>
